/*
	Release environment can be one of the following
	1. production - live environment
	2. beta - beta testing environment
	3. development - development environment
	4. local - local IP based environment
*/
const RELEASE_ENVIROMENT = "development";




/*
  web PC 电脑网页版 (blue) = 1
  web Mobile 手机网页版 (green) = 2
  Mobile APK 安卓版 (yellow) = 3
  Apple Bookmark 苹果书签版 (grey) = 4
  Apple TF 苹果 TF版 (cyan) = 5
*/
export const buildConfigs = {
	//web mobile
	buildType: 2,
	downloadPopup: true

	//bookmark
	// buildType: 4,
	// downloadPopup: false

	//APK
	// buildType: 3,
	// downloadPopup: false

	//Web Android version APK
	// buildType: 7,
	// downloadPopup: false
};


//test line change keys
export const backupAPIConfigs = {
	name: "fhzq_test",
	token: "8f9cdc3be549b9ca"
}

//live line change keys
// export const backupAPIConfigs = {
// 	name: "tOz0h3m894bm",
// 	token: "8f9cdc3be549b9ca"
// }




/* ========================TEST URLs=============================== */
// const PRODUCTION_BASE_URL = "";
// const BETA_BASE_URL = "";
// const LOCAL_BASE_URL = "";
export const DEVELOPMENT_BASE_URL = "https://api.fhzq.peizi.hkcorp.vip";
export const ALT_URL_1 = "https://api1.fhzq.peizi.hkcorp.vip";
export const ALT_URL_2 = "https://api2.fhzq.peizi.hkcorp.vip";

/* ========================LIVE UNI=============================== */
// const PRODUCTION_BASE_URL = "";
// const BETA_BASE_URL = "";
// const LOCAL_BASE_URL = "";
// export const DEVELOPMENT_BASE_URL = "https://113.207.49.239:5221";
// export const ALT_URL_1 = "https://fhusa.fhzqyapi.com:5221";
// export const ALT_URL_2 = "https://qzrb2.fhzqpc.com:5221";

/* ========================BOOKMARK URLs=============================== */
const PRODUCTION_BASE_URL = "";
const BETA_BASE_URL = "";
const LOCAL_BASE_URL = "";
// export const DEVELOPMENT_BASE_URL = "https://113.207.49.239:5221";
// export const ALT_URL_1 = "https://fhusabkm.fhzqyapi.com:5221";
// export const ALT_URL_2 = "https://qzrb2.fhzqpc.com:5221";

/* ========================LIVE APK URLs=============================== */
// const PRODUCTION_BASE_URL = "";
// const BETA_BASE_URL = "";
// const LOCAL_BASE_URL = "";
// export const DEVELOPMENT_BASE_URL = "https://113.207.49.157:5222";
// export const ALT_URL_1 = "https://fhusa.fhzqyapi.com:5221";
// export const ALT_URL_2 = "https://qzrb1.fhzqapk.com:5221";







/* ===========================TEST CHAT URL============================= */
const CHAT_BASE_URL = "https://tradechat.fhzq.peizi.hkcorp.vip";


/* ===========================LIVE CHAT URL============================= */
// const CHAT_BASE_URL = "https://fhchat.phonix678.com";








export const BASE_COLOR = '#ee5c35';
export const BASE_LABEL_COLOR = '#797979';

//When true, hides specific components of the UI
export const PREVIEW_MODE = false;

export {
	CHAT_BASE_URL,
	// CRM_TOKEN,
	// CRM_SOCKET_BASE,
	RELEASE_ENVIROMENT,
};

export function getSystemBaseURL() {
	switch (RELEASE_ENVIROMENT) {
		case "production":
			return PRODUCTION_BASE_URL;
			break;
		case "beta":
			return BETA_BASE_URL;
			break;
		case "development":
			return DEVELOPMENT_BASE_URL;
			break;
		case "local":
			return LOCAL_BASE_URL;
			break;
		default:
			break;
	}
}

/* Login */
export function getLoginEURL() {
	return "/app/User/login_e";
}

export function getUserSetIpUrl() {
	return "/app/User/update_ip";
}

export function getLoginURL() {
	return "/app/User/login";
}

export function getHomeURL() {
	return "/app/Home/index";
}

export function getLogoURL() {
	return "/app/Home/logo";
}

export function getNewsInfo() {
	return "/app/News/news_details";
}

export function getFoundWinnerInfoURL() {
	return "/app/FoundWinners/found_winner";
}

export function getSmsCodeURL() {
	return "/app/SendSms/register_code_e";
}

export function getRegisterURL() {
	return "/app/User/register_new_e";
}

export function getForgotPasswordURL() {
	return "/app/User/forgot_password_e";
}


export function getCaptchaURL() {
	return "/app/SendSms/getSmsPic";
}

export function getUserAccountURL() {
	return "/app/UserAccount/account";
}

export function getUserURL() {
	return "/app/User/user";
}

export function getUserInfoURL() {
	return "/app/User/user_info";
}

export function getAllLogURL() {
	return "/app/FlowLog/all_log";
}

export function getAcitivities() {
	return "/app/Home/active_activitylist";
}

export function getInactiveActivitiesURL() {
	return "/app/Home/active_unactivitylist";
}

export function getLanguageListURL(lang) {
	return `/app/i18n/list?lang=${lang}`;
}

export function getAboutUsList() {
	return "/app/Protocol/protocol";
}

export function getRiskControlList() {
	return "/app/RiskControl/risk_control";
}

export function getQuotesDetails() {
	return "https://qt.gtimg.cn/q=sh000001,sz399001,sz399006";
}

export function getAnnouncmentURL() {
	return "/app/Home/notice";
}

export function getRechargeInfoURL() {
	return "/app/Recharge/recharge_info";
}

export function getRechargeMaxAmountURL() {
	return "/app/Recharge/recharge_max_amount";
}

export function getSingleStockDataURL(stockCode) {
	return `https://qt.gtimg.cn/q=${stockCode}`;
}

export function getTimeSharingKlineDataURL(stockCode, timestamp) {
	return `https://ifzq.gtimg.cn/appstock/app/minute/query?code=${stockCode}&r=${timestamp}`;
}

export function getDayKlineDataURL(stockCode, timestamp, type) {
	return `https://ifzq.gtimg.cn/appstock/app/kline/kline?param=${stockCode},${type},,,320,&r=${timestamp}`;
}

export function getMinuteKlineDataURL(stockCode, timestamp) {
	return `https://ifzq.gtimg.cn/appstock/app/kline/mkline?param=${stockCode},m1,,,320,&r=${timestamp}`;
}

export function getQueryConcernURL() {
	return `/app/Concern/query_concern`;
}

export function getCancelQueryConcernURL() {
	return `/app/Concern/cancel_concern`;
}

export function getJoinQueryConcernURL() {
	return `/app/Concern/join_concern`;
}

export function getTimeBaoFundURL() {
	return `/app/Timebao/query_fund`;
}

export function getTimeBaoQueryLogURL() {
	return `/app/Timebao/query_log`;
}

export function getTimeBaoMoveInURL() {
	return `/app/Timebao/move_in`;
}

export function getTimeBaoMoveOutURL() {
	return `/app/Timebao/move_out`;
}

export function getSysConfigURL(type) {
	return `/app/Sysconfig/sysconfig/${type}`;
}

export function getRechargeHasURL() {
	return `/app/Recharge/recharge_has`;
}

export function getOfflineRechargeURL() {
	return `/app/Recharge/offline_recharge`;
}

export function getTradePopupURL() {
	return `/app/User/trade_popup`;
}

export function getRechargeSureURL() {
	return `/app/Recharge/recharge_sure`;
}

export function getPositionInquiryURL() {
	return "/app/Depot/all_depots";
}

export function getEntrustInquiryURL() {
	return "/app/Entrust/all_entrust";
}

export function getDealInquiryURL() {
	return "/app/Deal/all_deals";
}

export function getWithdrawInquiryURL() {
	return "/app/Entrust/all_cancel";
}

export function getNewsURL() {
	return "/app/News/index";
}

export function getNewsDetailsURL() {
	return "/app/News/news_details";
}

export function getQuotesDetailsURL() {
	return "/app/Stock/stock_page_data";
}

export function getQuotesTab2URL() {
	return "/app/Concern/concern";
}

export function getModifyNameURL() {
	return "/app/User/modify_name";
}

export function getRealNameURL() {
	return "/app/User/certification";
}

export function getBankInfoURL() {
	return "/app/UserBank/bank_info";
}

export function getBindBankURL() {
	return "/app/Bank/bind_bank";
}

export function getUpdatePhoneSmsCodeURL() {
	return "/app/SendSms/modifyinfo_code_e";
}

export function getUpdatePhoneURL() {
	return "/app/User/modify_phone_e";
}

export function getUpdateEmailURL() {
	return "/app/User/modify_email";
}

export function getWithdrawPasswordUpdateURL() {
	return "/app/User/modify_pay_e";
}

export function getLoginPasswordUpdateURL() {
	return "/app/User/modify_login_e";
}


export function getThirdPartyChatURL() {
	return "/app/Home/server_url";
}
export function getSimulationAccountURL() {
	return "/app/UserSimulate/login";
}
export function getIsAllStocksSold() {
	return "/app/Depot/allStocksSold";
}
export function getDetailedLogByTypeURL(logBase, logType) {
	return `/app/${logBase}/${logType}`;
}

export function getDayCapitalDataURL() {
	return `/app/Capital/day_info`;
}

export function getModifyTradeStatusURL() {
	return `/app/TradeChannalLog/modify_trade_status`;
}

export function getWeekCapitalDataURL() {
	return `/app/CapitalType/week_info`;
}

export function getMonthCapitalDataURL() {
	return `/app/Capital/month_info`;
}

export function getVIPCapitalDataURL() {
	return `/app/CapitalType/vip_info`;
}

export function getMutualInfoDataURL() {
	return `/app/CapitalType/mutual_info`;
}

export function getDepotStockURL() {
	return "/app/Depot/depot_stock";
}

export function getCancelOrderURL() {
	return "/app/Capital/cancel_order";
}

export function getEntrustLogURL() {
	return "/app/Capital/entrust_log";
}

export function getDealLogURL() {
	return "/app/Capital/deal_log";
}

export function getStockURL() {
	return "/app/Stock/get_stocks";
}

export function getBuyStockURL() {
	return "/app/Stock/buy_stock";
}

export function getSellStockURL() {
	return "/app/Stock/sell_stock";
}

export function getCapitalURL() {
	return "/app/Capital/current_operate";
}

export function getApplyCapitalURL(type) {
	return `/app/Capital/${type}`;
}

export function getPositionInquiryStockData(shorts) {
	return `https://qt.gtimg.cn/q=${shorts}`;
}

export function getHistoryOperateURL() {
	return `/app/Capital/history_operate`;
}

export function getHistoryDetailedURL() {
	return `/app/Capital/history_detailed`;
}

export function getWithdrawChannelURL() {
	return `/app/Withdraw/withdraw_channel`;
}

export function getWithdrawTypeUrl() {
	return `/app/Withdraw/withdraw_type`;
}

export function getAccountBankURL() {
	return `/app/UserBank/accountbank`;
}

export function getIsFirstRechargeURL() {
	return `/app/Recharge/isfirst_recharge`;
}

export function getIsFirstTradingURL() {
	return `/app/Deal/isfirst_deal`;
}

export function getWithdrawHasURL() {
	return `/app/Withdraw/withdrawHas`;
}

export function getCapitalSettlementURL() {
	return `/app/Capital/settlement`;
}

export function getCapitalAccountDetails() {
	return `/app/Capital/current_detailed`;
}

export function getWithdrawURL() {
	return `/app/Withdraw/withdraw`;
}

export function getCapitalLogURL() {
	return `/app/CapitalLog/capital_log`;
}

export function getActivityDetailURL() {
	return `/app/Home/active_activity`;
}

export function getIncreaseBondInfoURL() {
	return `/app/Capital/increase_bond_info`;
}

export function getIncreaseCapitalInfoURL() {
	return `/app/Capital/increase_capital_info`;
}

export function getIncreaseBondOperateURL() {
	return `/app/Capital/increase_bond_operate`;
}

export function getIncreaseCapitalOperateURL() {
	return `/app/Capital/increase_capital_operate`;
}

export function getCancelEntrustURL() {
	return `/app/Entrust/cancel_entrust`;
}

export function getAgentAccountURL() {
	return "/app/AgentAccount/agent_account";
}

export function getAgentFlowLogURL() {
	return "/app/AgentFlowLog/agent_flow_log";
}

export function getAgenWithdrawLogURL() {
	return "/app/AgentWithdraw/agent_withdraw";
}

export function getAgentCommissionLogURL() {
	return "/app/Agent/agent_commissioninfo";
}

export function getAgentQRcodeURL() {
	return "/app/Agent/agent_qrcode";
}

export function getFriendCouponQRcodeURL() {
	return "/app/FriendCoupon/coupon_url";
}

export function getMyTeamURL() {
	return "/app/Agent/agent_team";
}

export function getDailyDepotURL() {
	return "/app/AgentDailyDepot/agent_daily_depot";
}

export function getCheckInURL() {
	return "/app/FirstVoucher/checkin";
}

export function getFriendCouponURL() {
	return "/app/FriendCoupon/friend_coupon";
}

export function getMyCouponURL() {
	return "/app/UserCoupon/my_coupon";
}

export function getAgentWithdrawURL() {
	return "/app/AgentWithdraw/agent_dowithdraw";
}

export function getAgentTransferURL() {
	return "/app/AgentWithdraw/transfer_money";
}

export function getAgentListURL() {
	return "/app/Chat/agentList";
}

export function getChatHistoryURL() {
	return "/app/Chat/getHistory";
}

export function sendMessages() {
	return "/app/Chat/send";
}

export function getChatMessages() {
	return "/app/Chat/get";
}

export function markChatMsgsAsRead() {
	return "/app/Chat/readMsg";
}

export function uploadChatFiles() {
	return "/app/Chat/Upload/upload";
}

export const EMOJI_ICONS = ["微笑", "爱你", "拜拜", "悲伤", "鄙视", "闭嘴", "馋嘴", "吃惊", "鼓掌", "哈哈", "害羞", "黑线", "可爱", "可怜", "亲亲",
	"生病", "偷笑", "挖鼻",
	"委屈"
];
export function getHomePageComponentsOrder() {
	return "/app/Components/components";
}

export function getChatMessageOfflineURL() {
	return "/app/Chat/getOfflineMsg";
}

export function getMaxCouponData() {
	return "/app/UserCoupon/is_query_max_coupon";
}

export function getStockFeeData() {
	return "/app/Stock/stockFee";
}

// Auto login after register
export function getLoginAfterRegister() {
	return "/app/User/registerLogin";
}

// Get otp code for set phone popup
export function getSetPhoneOtp() {
	return "/app/SendSms/popupCode";
}

// Get set phone api
export function getSetPhoneUrl() {
	return "/app/User/popupPhone";
}

// Get forgot login name url
export function getForgotLoginNameUrl() {
	return "/app/User/forgotUsername_e";
}

// Get username validation
export function getValidateUsername() {
	return "/app/User/user_validate";
}

// Get download page data
export function getDownlowdpageDetails() {
	return "/admin/Baseconfig/downloadPage";
}

export function getAccountPageComponentsOrder() {
	return "/app/Components/accountComponents";
}
export function getNewAccountPageComponentsOrder() {
	return "/app/Components/newaccountComponents";
}

export function getRedenvWithdrawlogURL() {
	return "/app/RedEnvelopeManagement/withdraw_log";
}
export function getRedenvAllLogsURL() {
	return "/app/RedEnvelopeManagement/all_log";
}
export function getRedenvRechargelogURL() {
	return "/app/RedEnvelopeManagement/recharge_log";
}
export function getRedenvDeallogURL() {
	return "/app/RedEnvelopeManagement/deal_log";
}
export function getRedenvInfoURL() {
	return "/app/RedEnvelopeManagement/red_envelop_info";
}
export function getWithdrawRedeemURL() {
	return "/app/RedEnvelopeManagement/withdraw_redeem";
}
// Get greeting message for agent
export function getGreetingMessage() {
	return "/app/message/greeting";
}

// Mark a chat msg as delivered
export function getMarkChatDelivered() {
	return "/app/Chat/markDelivered";
}

export function getGxpayThirdpartyCurrencyInfoURL() {
	return "/app/Recharge/gxpay_thirdparty_digital_currency";
}

// Get Deleted messages
export function getDeletedMsgs() {
	return "/app/Chat/getDeletedMsg";
}

export function getChatUrlRes() {
	return "/app/Chat/apitest";
}

export function getBackupAPIConfigsUrl() {
	return "/app/BackupSettings/index";
}

export function getStockInfoURL() {
	return "/app/Stock/get_stock_info";
}
// Get unread risk notices
export function getUnreadRiskNoticeUrl() {
	return "/app/RiskControl/user_unread_risk_control";
}

// update unread risk notices to read
export function updateUnreadRiskNoticeUrl() {
	return "/app/RiskControl/user_read_risk_control";
}